export const aggregationOptions = [
  'app_key',
  'device_type',
  'country',
  'ua_source',
  'ua_campaign_name',
  'ua_adset_name',
  'date',
  'week',
  'month',
].map((value) => ({ label: value, value }))

export const topCountriesCountOptions = [
  { label: '5', value: '5' },
  { label: '10', value: '10' },
  { label: '30', value: '30' },
  { label: '50', value: '50' },
  { label: '100', value: '100' },
]
